// 改行を2文字として数えた場合の文字数
export const textAndLineBreakLength = (text: string): number =>
  text.replace(/(\r\n|\n|\r)/g, "").length + (text.match(/(\r\n|\n|\r)/g) || []).length * 2;
